/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Streak_LineInputs */

const en_us2_share_streak_line = /** @type {(inputs: Share_Streak_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consistency is what counts most.`)
};

const pt_br2_share_streak_line = /** @type {(inputs: Share_Streak_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constância é o que mais conta.`)
};

const es_419_share_streak_line = /** @type {(inputs: Share_Streak_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La constancia es lo que más cuenta.`)
};

const pt_pt2_share_streak_line = /** @type {(inputs: Share_Streak_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A constância é o que mais conta.`)
};

const fr_fr2_share_streak_line = /** @type {(inputs: Share_Streak_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La régularité est ce qui compte le plus.`)
};

const de_de2_share_streak_line = /** @type {(inputs: Share_Streak_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beständigkeit zählt am meisten.`)
};

const it_it2_share_streak_line = /** @type {(inputs: Share_Streak_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La costanza è ciò che conta di più.`)
};

/**
* | output |
* | --- |
* | "Consistency is what counts most." |
*
* @param {Share_Streak_LineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_streak_line = /** @type {((inputs?: Share_Streak_LineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Streak_LineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_streak_line(inputs)
	if (locale === "es-419") return es_419_share_streak_line(inputs)
	if (locale === "pt-PT") return pt_pt2_share_streak_line(inputs)
	if (locale === "fr-FR") return fr_fr2_share_streak_line(inputs)
	if (locale === "de-DE") return de_de2_share_streak_line(inputs)
	if (locale === "it-IT") return it_it2_share_streak_line(inputs)
	return en_us2_share_streak_line(inputs)
});
export { share_streak_line as "share.streak_line" }